import React from 'react';
import { useParams } from 'react-router-dom';
import PoliciesList from '../../components/compliance/policies/PoliciesList';

const CompliancePoliciesPage = () => {
  const { projectId } = useParams();

  return (
    <div className="max-w-6xl mx-auto p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Policies</h1>
        <p className="text-sm text-gray-500 mt-1">
          Manage and generate compliance policies for your project.
        </p>
      </div>
      <PoliciesList projectId={projectId} />
    </div>
  );
};

export default CompliancePoliciesPage;
